import { enableProdMode } from '@angular/core';
import {bootstrapApplication,} from '@angular/platform-browser';

import { environment } from './environments/environment';

import { init } from '@sentry/angular';

import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';

import {RELEASE} from "src/release";

if (environment.production) {
    enableProdMode();
    // Sentry
    init({
        dsn: environment.sentry_dsn,
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
        ],
        release: RELEASE
    });
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
